import { getSelectedTableView } from "owa-mail-list-store";
import type { InboxRuleActionSource } from "owa-inbox-rules-option";
import { lazyCreateRuleFromRow } from "owa-mail-inbox-rules";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";

export default async function onCreateRule(actionSource: InboxRuleActionSource, targetWindow?: Window): Promise<void> {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    if (!tableView) {
        return;
    }
    const rowKeys = getEffectiveRowKeys(tableView);
    
    const createRuleFromRow = await lazyCreateRuleFromRow.import();
    createRuleFromRow(rowKeys[0], tableView.id, actionSource, targetWindow);
}
